<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 19:30:06
-->
<template>
  <veStuHygieneModify viewType="my" slot="table"></veStuHygieneModify>
</template>

<script>
import veStuHygieneModify from './base/veStuHygieneModify';
export default {
  components: {
    veStuHygieneModify
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
